import React, { useState } from 'react'
import fire from './Firebase'
import iconInsta from './assets/insta.png'
import iconWhatsapp from './assets/wa.png'
import iconFb from './assets/fb.png'
import iconEmail from './assets/email.png'
import iconLinkedin from './assets/linkedin.png'
import Slide from 'react-reveal/Slide';

function Contact(props) {
    const [name, setname] = useState('')
    const [email, setemail] = useState('')
    const [phonenum, setphonenum] = useState('')
    const [msg, setmsg] = useState('')
    const [isSubmit, setIsSubmit] = useState(false)
    const themeColors = props.themeColors
    const darkMode = props.darkMode

    const socialContact = [
        { name: 'LinkedIn', link: 'https://www.linkedin.com/in/brahmharsh/', ico: iconLinkedin },
        { name: 'Email', link: 'mailto:brahmharsh24@gmail.com', ico: iconEmail },
        { name: 'Instagram', link: 'https://www.instagram.com/okbrahm/', ico: iconInsta },
        { name: 'Whatsapp', link: 'https://wa.me/917983459643', ico: iconWhatsapp }
    ]

    const btnSubmit = () => {
        if (name === '' || email === '' || phonenum === '' || msg === '') {
            alert('Please fill all the details')
        } else {
            fire.firestore().collection('contacts/').add(
                {
                    name: name,
                    email: email,
                    phone: phonenum,
                    message: msg
                }
            ).then(() => {
                setIsSubmit(true)
            }).catch((err) => {
                alert(err)
            })
        }
    }
    return (
        <div style={{ flex: 1, overflow: 'auto', height: 'auto', overflowX: 'hidden' }}>
            {/* <div style={{ display: 'flex', backgroundColor: darkMode ? themeColors.darkOn.container.secondary : themeColors.darkOff.container.secondary, alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingTop:20, paddingBottom: 20 }}>
                <input onChange={(e) => setname(e.target.value)} style={{ marginBottom: 3, width: 170, border: 'solid .1px grey', padding:10, borderRadius:0 }} type="text" placeholder="Name" />
                <input onChange={(e) => setemail(e.target.value)} style={{ marginBottom: 3, width: 170, border: 'solid .1px grey', padding:10, borderRadius:0 }} type="email" placeholder="Email" />
                <input onChange={(e) => setphonenum(e.target.value)} style={{ marginBottom: 3, width: 170, border: 'solid .1px grey', padding:10, borderRadius:0 }} type="tel" placeholder="Phone Number" />
                <textarea onChange={(e) => setmsg(e.target.value)} style={{ marginBottom: 3, width: 170, border: 'solid .1px grey', padding:10, borderRadius:0 }} type="text" placeholder="Message" />
                {isSubmit ? <div style={{ marginTop: 15, display: 'flex', alignItems: 'center', justifyContent: 'center', width: 180, padding:5, height:30 }}><p>Submitted <span style={{ color: 'green' }}>&#10004;</span></p></div>
                    :
                    <div onClick={btnSubmit} style={{ marginTop: 15, width:180, display: 'flex', alignItems: 'center', justifyContent: 'center', height: 30, backgroundColor:darkMode? themeColors.darkOn.main.secondary : themeColors.darkOff.main.secondary, cursor: 'pointer', border:'.1px solid #ffff', padding:5 }}><p>Submit</p></div>
                }
            </div> */}
            {
                socialContact.map((items) => <div key={items.name} style={{ display: 'flex', backgroundColor: darkMode ? themeColors.darkOn.container.secondary : themeColors.darkOff.container.secondary, height: 70, marginBottom: 5, marginTop: 5, cursor: 'pointer' }}>

                    <a href={items.link} target="_blank" style={{ flex: 1, display: 'flex', textDecoration: 'none', color: 'inherit' }}>
                        <Slide right>
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', paddingRight: 3 }}>
                                <img alt="img" style={{ height: 30, width: 30, background: items.name === "LinkedIn" && "white", borderRadius: items.name === "LinkedIn" && "4px"}} src={items.ico} />
                            </div>
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', paddingLeft: 3 }}>
                                <p>{items.name}</p>
                            </div>
                        </Slide>
                    </a>

                </div>)
            }
        </div>
    )
}

export default Contact